import { Outlet } from "react-router-dom";
import Sidebar from "../sidebar/Sidebar";
import "./style.scss";

const AppLayout = () => {
    return <div className="lay">
        <Sidebar />
        <Outlet />
    </div>;
};

export default AppLayout;
